import { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { redirect, routes } from '~/constants';
export function RedirectPage() {
    const navigate = useNavigate();
    const { search } = useLocation();
    const returnTo = useMemo(()=>redirect.getReturnToFromSearch(search), [
        search
    ]);
    useEffect(()=>{
        navigate(returnTo || routes.home, {
            replace: true
        });
    }, [
        returnTo
    ]);
    return null;
}
